import ActivityCard, { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.MessageTemplateActivity
}

export const InvitationTemplateActivityCard = (props: Props) => {
  const { activity } = props;
  return <ActivityCard
    activity={activity}
  >
    <DefaultActivityContent activity={activity} />
  </ActivityCard>
}